import React from 'react';
import {observer} from "mobx-react-lite";
import {BottomNavigationBarComponent} from "../../bottom-navigation-bar/bottom-navigation-bar.component";
import {VideoSlidesArenaBox} from "./boxes/video-slides-arena.box";
import {VideoSlidesContentArena} from "./video-slides-arena-content/video-slides-arena-content.component";
import {VideoSlidesHeaderArena} from "./video-slides-arena-header/video-slides-arena-header.component";

export const VideoSlidesArena: React.FC= observer(() => {

    return (
        <VideoSlidesArenaBox>
            <VideoSlidesHeaderArena />
            <VideoSlidesContentArena />
            <BottomNavigationBarComponent isInVideoSlidesArena={true} />
        </VideoSlidesArenaBox>
    );
})